const allocationBillableTypes = {
  billable: { id: 'billable', name: 'Client Billable' },
  non_billable: { id: 'non_billable', name: 'Client Non-Billable' },
  internal: { id: 'internal', name: 'Internal' },
  time_off: { id: 'time_off', name: 'Time Off' },
};

export default allocationBillableTypes;
